import type {
    CollectionFragment,
    MetadataFragment,
    ParentCollectionFragment,
    ProfileFragment,
} from '~/lib/graphql/graphql.ts'

export function formatDateTime(date: string) {
    return new Date(Date.parse(date)).toLocaleDateString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
    }).replace(',', '')
}

export function getPageLink(item: CollectionFragment | MetadataFragment) {
    const slug = item?.slug || item?.id
    if (item?.__typename === 'Collection') {
        if (item.attributes['type'] === 'Author') {
            return '/people/' + slug
        }
        return '/collections/' + slug
    }
    if (item?.__typename === 'Metadata') {
        switch (item.attributes['type']) {
        case 'Article':
            return '/articles/' + slug
        case 'Talk':
            return '/talks/' + slug
        case 'Worship':
            return '/worship/' + slug
        case 'Podcast':
            return '/podcasts/' + slug
        case 'Study':
            return '/studies/' + slug
        }
    }
    return ''
}

export function getFeaturedImageUrl(
    item: CollectionFragment | MetadataFragment | null | undefined,
    r?: string | undefined,
): string | null {
    if (!item) return null
    const relationship = r || 'image.featured'
    let metadata: MetadataFragment | null = null
    if (item?.__typename === 'Collection') {
        metadata = item.metadataRelationships?.find(a =>
            a.relationship === relationship,
        )?.metadata as MetadataFragment | null
    }
    if (item?.__typename === 'Metadata') {
        metadata = item.relationships?.find(a => a.relationship === relationship)
            ?.metadata as MetadataFragment | null
    }
    if (metadata) {
        try {
            const baseUrl = useRuntimeConfig().public.imageBaseUrl
            return baseUrl + '/' + metadata.slug + '.jpeg?key=size-medium-jpeg'
        }
        catch (e) {
            console.error(e)
        }
    }
    return null
}

export function getAuthor(
    item: CollectionFragment | MetadataFragment | ProfileFragment | null,
): ParentCollectionFragment | null | undefined {
    let collections: ParentCollectionFragment[]
    if (item?.__typename === 'Metadata') {
        collections = item.parentCollections
    }
    else if (item?.__typename === 'Collection') {
        collections = item.parentCollections
    }
    else {
        collections = []
    }
    return collections.find(a => a.attributes['type'] === 'Author')
}
